/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFileHorizontal = createReactComponent("outline", "file-horizontal", "IconFileHorizontal", [["path", { "d": "M16 5v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z", "key": "svg-1" }]]);

export { IconFileHorizontal as default };
//# sourceMappingURL=IconFileHorizontal.mjs.map
